import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { PropertyDataDisplay } from 'utilities/propertyDataDisplay';
import { IAugmentedJQuery } from 'angular';
import { isCondoPolicy } from 'common/source/utilities/policyInfoHelper';

const module = angular.module('overview-basic-information-section', []);

interface OverviewBasicInformationSectionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    propertyDataDisplay: PropertyDataDisplay;
}

module.component('overviewBasicInformationSection', {
    bindings: {
        policyInfo: '<'
    },
    template: template,
    controller: function(this: OverviewBasicInformationSectionController, $element: IAugmentedJQuery) {
        this.$onInit = function() {
            this.propertyDataDisplay = new PropertyDataDisplay(this.policyInfo.property_data);

            if (isCondoPolicy(this.policyInfo)) {
                $element.addClass('ng-hide');
            }
        };
    }
});

export { module };
